<span class="editor-label" [ngClass]="{'float': editorFocused || model?.length, 'disabled': disabled, 'text-warning': !valid || requiredButEmpty}" *ngIf="label">
  {{ label | translate }}
  <span class="text-warning" *ngIf="required && !disabled">*</span>
</span>
<quill-view-html *ngIf="disabled" [content]="model || '-'" [sanitize]="true"></quill-view-html>
<ng-container *ngIf="!disabled">
  <quill-editor #editor class="break-word" [ngClass]="{'editor-warning': !valid || requiredButEmpty}"
                [placeholder]="(placeholder || '') | translate" [id]="id" [sanitize]="true"
                (focusin)="editorFocused = true; visited = true" (focusout)="editorFocused = false"
                [modules]="modules" [customOptions]="customOptions"
                (onEditorCreated)="setup()"
                (onEditorChanged)="handleContent($event)"
                [(ngModel)]="model" (ngModelChange)="modelChanged.emit(); inputDirty = true" [readOnly]="disabled">
  </quill-editor>

  <span class="editor-hint text-muted"
        [ngClass]="{'flex max-width': max, 'space-between': max && (!valid || requiredButEmpty || hint), 'flex-end': max && !hint && valid && !requiredButEmpty}"
        *ngIf="hint || max || !valid || requiredButEmpty">
    <span class="text-warning" *ngIf="!valid || requiredButEmpty">
      <mat-icon class="svg-icon" [svgIcon]="'warning'"></mat-icon>
      {{ (error ? error : 'general.api_editor_content_invalid') | translate: {maxLength: max} }}
    </span>
    <span *ngIf="hint && valid && !requiredButEmpty">
      <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
      {{ hint | translate }}
    </span>
    <span class="hint-spacer" [ngClass]="{'text-warning': !valid && !requiredButEmpty}" *ngIf="max">
      {{ (modelAsText?.length || 0) }}/{{ max }}
    </span>
  </span>
</ng-container>
